// extracted by mini-css-extract-plugin
export var cardHeader = "_hf-0";
export var reorderHandle = "_hf-3";
export var titleArea = "_hf-1";
export var titleAreaWithHandle = "_hf-2";